export default __webpack_public_path__ + "static/media/val-poster.c585d08f.png";